import { AllowedAccess } from 'react-permission-role'
import { useLocation, useParams } from 'react-router-dom'
import {
    Box,
    Button,
    Card,
    CardContent
} from '@mui/material';

import { useFetchInitCashierAssignment } from './hooks'
import { MainSection } from './MainSection'
import { FormAssignment } from './FormAssignment'
import { ModalModule } from './ModalModule'


export const CashierAssignment = () => {

    const location = useLocation();
    const paramsURL = useParams();
    const useFetchInit = useFetchInitCashierAssignment({location, paramsURL})

    const { Actions, globalStates } = useFetchInit

    const { handleClickShowForm } = Actions
    const { showForm } = globalStates


    return (
        <AllowedAccess permissions={['243_ASIGNACION']} renderAuthFailed={<p>Error</p>}>
            <ModalModule useFetchInit={useFetchInit}/>
            {(!showForm) && (
                <Card sx={{ zIndex: 1 }}>
                    <CardContent>
                        
                        <div className='h4 mt-1 mb-1'> Cajas: Asignaciones </div>
                        <div className="border-bottom border-dark"></div>

                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: 3, pb: 3 }}>
                            <Button
                                sx={{ backgroundColor: '#4b4b4c' }}
                                variant="contained"
                                type="button"
                                onClick={handleClickShowForm}
                            >
                                + Agregar
                            </Button>
                        </Box>

                        <MainSection useFetchInit={useFetchInit} />

                    </CardContent>
                </Card>
            )}
            {(showForm) && (
                <FormAssignment useFetchInit={useFetchInit} />
            )}
            
        </AllowedAccess>
    )
}
